import React, { useEffect, useState } from "react"
import CRMService from "src/services/CRMService"
import {
  Checkbox,
  Col,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
} from "antd"
import dayjs from "dayjs"
import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons"
import HRService from "src/services/HumanResource"
import Button from "src/components/MyButton/Button"
import notice from "src/components/Notice"
import { FooterStyle } from "src/pages/ADMIN/Bussiness/customer/common/styled"
// import {
//   initialValues,
//   TimeFormList,
//   TYPE,
// } from "src/pages/ADMIN/Bussiness/salary/SalaryConfig"
import { initialValues, TimeFormList, TYPE } from "./SimPriceConfig"
import SettingPriceService from "src/services/SettingPriceService"
import { set } from "lodash"
export const formatPrice = value => {
  if (value == null || value === "") return ""

  // Loại bỏ dấu phẩy nếu có
  let raw = value.toString().replace(/,/g, "")

  // Bỏ phần thập phân nếu là ".00"
  if (raw.includes(".")) {
    const [intPart, decimalPart] = raw.split(".")
    if (decimalPart === "00") {
      raw = intPart
    }
  }

  // Định dạng lại với dấu phẩy ngăn cách hàng nghìn
  return raw.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

function ModalUpdatePrice({ priceConfigId, getListPriceConfig, onCancel }) {
  const [type, setType] = useState()
  const [btnLoading, setBtnLoading] = useState(false)
  const [listDepartment, setListDepartment] = useState([])
  const [listPersonnel, setListPersonnel] = useState([])
  const [detailPriceConfig, setDetailPriceConfig] = useState(null)
  const [initialSettings, setInitialSettings] = useState({})
  const [form] = Form.useForm()
  const fetchSimDetailList = async () => {
    try {
      const res = await SettingPriceService.getDetailPrice(priceConfigId) // gọi API lấy danh sách sim
      if (res?.success) {
        const settingsWithNumberPrice = res.success.settings.map(item => ({
          ...item,
          price: formatPrice(item.price),
        }))
        form.setFieldsValue({
          note: res.success.note,
          start_time: res.success.start_time
            ? dayjs(res.success.start_time)
            : null,
          settings: settingsWithNumberPrice,
        })
        setDetailPriceConfig(settingsWithNumberPrice)
      }
    } catch (err) {
      console.error("Lỗi lấy danh sách sim", err)
    }
  }
  useEffect(() => {
    fetchSimDetailList()
  }, [])

  const updateConfigPrice = (id, payload) => {
    setBtnLoading(true)
    SettingPriceService.updatePrice(id, payload)
      .then(res => {
        notice({
          msg: "Giá bán đã được cập nhật!",
          isSuccess: true,
        })
        getListPriceConfig()
        onCancel()
      })
      .catch(err => {
        notice({
          msg: "Đã xảy ra lỗi. Vui lòng thử lại!",
          isSuccess: false,
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleOnSave = async () => {
    try {
      const values = await form.validateFields()

      console.log(values, "values")
      const payload = {
        ...values,
        start_time: dayjs(values.start_time).format("YYYY-MM-DD"),
        settings: values.settings.map(item => ({
          ID: item.ID,
          price:
            typeof item.price === "string"
              ? Number(item.price.replace(/,/g, ""))
              : Number(item.price),
        })),
      }
      console.log(payload, "payload")
      updateConfigPrice(priceConfigId, payload)
    } catch (err) {
      console.error("err", err)
      notice({
        msg: "Có lỗi xảy ra, vui lòng thử lại!",
        isSuccess: false,
      })
    }
  }

  const renderFooter = () => (
    <FooterStyle>
      <Button
        btnType="default"
        style={{ marginRight: 10 }}
        className="btn-hover-shadow"
        onClick={() => onCancel()}
      >
        Hủy bỏ
      </Button>
      <Button
        style={{ minWidth: "76px" }}
        btnType="primary"
        className="btn-hover-shadow"
        onClick={handleOnSave}
      >
        {btnLoading ? <LoadingOutlined /> : "Cập nhật"}
      </Button>
    </FooterStyle>
  )

  return (
    <div
      style={{ display: "flex", flexDirection: "column", marginBottom: "60px" }}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name="start_time"
              label="Ngày áp dụng"
              rules={[
                {
                  required: true,
                  message: "Không được để trống!",
                },
              ]}
            >
              <DatePicker
                disabledDate={current =>
                  current && current < dayjs().startOf("day")
                }
                style={{ height: "37px" }}
                format="DD/MM/YYYY"
                placeholder="Nhập ngày"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="note"
              label="Ghi chú"
              rules={[
                {
                  required: true,
                  message: "Không được để trống!",
                },
              ]}
            >
              <Input.TextArea rows={2} placeholder="Nhập ghi chú" />
            </Form.Item>
          </Col>
        </Row>
        <TimeFormList form={form} initialValues={detailPriceConfig} />
      </Form>
      {renderFooter()}
    </div>
  )
}

export default ModalUpdatePrice
